
<template>
  <Container  class="index-body" :isLoadingShow="isLoadingShow">
    <div class="search-body vh">
      <div class="content">
        <div class="input">
            <input type="text" v-model="keyword" :placeholder="this.getPlaceholder()" v-on:keyup.enter="doSearch">
              <!--  <span></span> -->
        </div>
        <div class="text-content">
          <p class="img-text" v-if="false"><img src="../../assets/img/search-text.png"></p>

          <div v-if="this.newsSet.length>0">

          <p class="text" v-for="(category,index) in this.categorySet" :key="index" >

            <template >
              <div v-for="(news,index) in getList(category.ID)" :key="index">
               <a href="javascript:;" @click="$goToProjectDetail(news.ID)" >{{news.NewsTitle}}</a>  <br>
               </div>
            </template>

   
            
            </p>
            </div>

            <div  v-else-if="this.keyword!=''&&this.newsSet.length==0">

              <span :class="'title-'+getLanguageName">{{this.tips}}</span>


            </div>
            
        </div>
      </div>
    </div>
  </Container>
</template>


<script>
import Container from '@/components/Container.vue'

export default {
  name: "search",
  components: {Container},
   data() {
    return {
      
      isLoadingShow:true,
      model:[],
      keyword:'',
      placeholder:'',
      newsSet:[],
      categorySet:[],
      tips:''


    }
  },
  methods: {

    getData(){

      this.isLoadingShow = false
      //this.getPlaceholder()

    },

    getPlaceholder(){

      if(this.$store.state.language.name==='cn'){
        this.placeholder = "请输入关键词"
      }else{
        this.placeholder = "Please enter a keyword"
      }       

    },

    changeData(){
      if(this.model){
         this.getNewsSet()


      }

      this.getTips()

      

     
     // this.getPlaceholder()
    },

    getNewsSet(){
      this.newsSet = []
      this.categorySet = []
      if(this.model&&this.model.length>0){
        this.model.forEach(item=>{

          let categoryInfo = this.categorySet.find(info=>info.ID==item.BigCategoryID)
            if(!categoryInfo){
                this.categorySet.push({ID:item.BigCategoryID})
          }
          
           if(this.$store.state.language.name==='cn'){
              this.newsSet.push({ ID:item.ID,NewsTitle:item.NewsTitle,Src:item.Picture5.split(','),BigCategoryID:item.BigCategoryID})
          }else{
              this.newsSet.push({ ID:item.ID,NewsTitle:item.NewsTitleEn,Src:item.Picture5.split(','),BigCategoryID:item.BigCategoryID})
          }         
        })
      }

    },

    doSearch(){
      if(this.keyword){

          this.$request.get("/search",{params:{keyword:this.keyword,language:this.$store.state.language.name}}).then((res)=>{

          if (res.data.code === 0) {
              this.model= res.data.data;
              this.changeData();
          } 
        })
      }else{


        this.tips = ''
        this.model = []
        this.newsSet = []
        this.categorySet = []
        //this.changeData();
      }

    },

    getList(categoryID){

      let set = []
      if(this.newsSet&&this.newsSet.length>0){

        set =  this.newsSet.filter(item=>item.BigCategoryID==categoryID)
      }

     //  console.log(JSON.stringify(set))

      return set

    },

    getTips(){

      if(this.newsSet.length>0){
        this.tips = ''
      }else{
        if(this.$store.state.language.name=="cn"){
          this.tips = '抱歉～未找到符合条件的信息'
        }else{
          this.tips = 'Sorry ~ no matching information was found'
        }
      }

   
    },


 /*    keyDownSearch(e){
        var theEvent = e || window.event;  
        var code = theEvent.keyCode || theEvent.which || theEvent.charCode;  
        if (code == 13) {   
            this.doSearch();//具体处理函数  
            return false;  
        }  
        return true;

    } */
  },

  computed: {
    getLanguageName(){
      return this.$store.state.language.name
    },
  },

  mounted() {

   // document.onkeydown=this.keyDownSearch; 
  
    this.getData()

  },
  watch:{

    getLanguageName(){

      this.keyword = ''
      this.model = []
      this.newsSet = []
      this.categorySet = []

      this.changeData()
      
    }

  }  
}
</script>
